import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import UserService from "Services/http/endpoints/user/UserService";
import {read} from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import {ReactSVG} from "react-svg";
import checkBoxCheckedIcon from "Assets/svg/icon/checkbox-checked.svg";
import checkBoxIcon from "Assets/svg/icon/checkbox.svg";
import { useTranslation } from 'react-i18next';


function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function TransferUser({ groupedAgents, unGroupedAgents, superVisorKey }) {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);
  const [data, setData] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = async () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    await fetchTransfer(1, leftChecked);
  };

  const handleCheckedLeft = async () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    await fetchTransfer(2, rightChecked);
  };

  const customList = (title, items) => (
    <Card className="transferUser" variant="outlined">
      <CardHeader
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            // checkedIcon={<ReactSVG src={checkBoxCheckedIcon} />}
            // icon={<ReactSVG src={checkBoxIcon} />}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "all items selected" }}
          />
        }
        title={<Translator id={title} />}
        subheader={`${numberOfChecked(items)}/${items.length} ${t('selected')}`}
      />
      <Divider />
      <List className="transferList" dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;
          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                  // checkedIcon={<ReactSVG src={checkBoxCheckedIcon} />}
                  // icon={<ReactSVG src={checkBoxIcon} />}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={data[value]?.DisplayName}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  const fetchTransfer = async(type, indexes ) => {
    const keys = indexes.map(index => data[index].Key);
    try{
      const data = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
        KeySuperVisor: superVisorKey,
        KeySlaves: keys,
        TypeTransfer: type
      }
      const response = await UserService.postTransferAgent(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
       showNotify({text: t('mission_accomplished'), customClass:"success"});
      }
    }catch (e) {

    }
  }

  useEffect(() => {
    if(groupedAgents && unGroupedAgents) {
      if (groupedAgents?.length > 0) {
        const rightIndex = groupedAgents.map((x, i) => i);
        setRight(rightIndex);
      }
      if (unGroupedAgents?.length > 0) {
        const leftIndex = unGroupedAgents.map(
            (x, i) => i + groupedAgents?.length
        );
        setLeft(leftIndex);
      }
      setData(groupedAgents.concat(unGroupedAgents))
    }

  }, [groupedAgents, unGroupedAgents]);

  return (
    <Grid container className="d-flex flex-column flex-sm-nowrap flex-sm-row  justify-content-center align-items-center g-3">
      <Grid item className="flex-grow-1" style={{maxWidth: '240px'}}>{customList("groupedAgents", right)}</Grid>

      <Grid item className="flex-grow-1" style={{maxWidth: '240px'}}>
        <Grid container className="d-flex flex-row flex-sm-column justify-content-center align-items-center g-2">
          <MuiButton
            variant="outlined"
            className="justIcon on-n90-sm-rotate"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
            startIcon={<ArrowForwardIos />}
          />
          <MuiButton
            variant="outlined"
            className="justIcon on-n90-sm-rotate"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            startIcon={<ArrowBackIos />}
            aria-label="move selected left"
          />
        </Grid>

      </Grid>
      <Grid item className="flex-grow-1" style={{maxWidth: '240px'}}>{customList("unGroupedAgents", left)}</Grid>
    </Grid>
  );
}
